var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.country)?_c('div',{staticClass:"country-tag"},[(!_vm.onlyName)?_c('country-flag',{attrs:{"code":_vm.country.code}}):_vm._e(),(!_vm.onlyFlag)?_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.country.name))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }